/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Calf_RaiseInputs */

const en_us2_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`calf raise`)
};

const pt_br2_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`panturrilha`)
};

const es_419_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pantorrilla`)
};

const pt_pt2_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gémeos`)
};

const fr_fr2_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mollets`)
};

const de_de2_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wadenheben`)
};

const it_it2_catalog_movement_calf_raise = /** @type {(inputs: Catalog_Movement_Calf_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`polpacci`)
};

/**
* | output |
* | --- |
* | "calf raise" |
*
* @param {Catalog_Movement_Calf_RaiseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_calf_raise = /** @type {((inputs?: Catalog_Movement_Calf_RaiseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Calf_RaiseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_calf_raise(inputs)
	if (locale === "es-419") return es_419_catalog_movement_calf_raise(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_calf_raise(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_calf_raise(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_calf_raise(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_calf_raise(inputs)
	return en_us2_catalog_movement_calf_raise(inputs)
});
export { catalog_movement_calf_raise as "catalog.movement.calf_raise" }